import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Paginas from '@/views/Paginas'
import Compra from '@/views/Comprar'
import Pagamento from '@/views/Pagamento'
import Carrinho from '@/views/Carrinho'
import Conclusao from '@/views/Conclusao'
import Cardapio from '@/views/Cardapio'
import ConfirmarCadastro from '@/views/ConfirmarCadastro'
import Login from '@/views/Login.vue'
import LoginCpf from '@/views/LoginCpf.vue'

import Cadastrar from '@/views/Cadastrar.vue'
import MinhaConta from '@/views/MinhaConta.vue'
import AtualizarCadastro from '@/views/AtualizarCadastro.vue'

import Menu from '@/views/Menu.vue'
import CarrinhoFooter from '@/views/CarrinhoFooter'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: Home
    },
    /* Routers do Cadastro */
    {
      path: '/confirmar-cadastro/:token',
      name: 'ConfirmarCadastro',
      component: ConfirmarCadastro,
      props: true
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      props: true
    },
    {
      path: '/logincpf',
      name: 'LoginCpf',
      component: LoginCpf
    },
    {
      path: '/cadastrar',
      name: 'Cadastrar',
      component: Cadastrar,
      props: true
    },
    {
      path: '/cadastro',
      name: 'AtualizarCadastro',
      component: AtualizarCadastro,
      props: true
    },
    {
      path: '/minhaconta',
      name: 'Minha Conta',
      component: MinhaConta
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/comprar/:id',
      name: 'Comprar',
      component: Compra,
      props: true
    },
    {
      path: '/carrinho/:id',
      name: 'Carrinho',
      component: Carrinho,
      props: true
    },
    {
      path: '/carrinhof/:id',
      name: 'Carrinho Footer',
      component: CarrinhoFooter,
      props: true
    },
    {
      path: '/pagamento/:id',
      name: 'Pagamento',
      component: Pagamento,
      props: true
    },
    {
      path: '/conclusao/:id',
      name: 'Conclusao',
      component: Conclusao,
      props: true
    },
    {
      path: '/cardapio',
      name: 'Cardapio',
      component: Cardapio,
      props: true
    },
    {
      path: '/pagina/:id',
      name: 'Paginas',
      component: Paginas,
      props: true
    }
  ],
  scrollBehavior () {
    return window.scrollTo({ top: 0, behavior: 'smooth' })
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js